import { useColorModeValue } from "@chakra-ui/react";
import { MOISTURE_INDEX_LIGHT_BLUE } from "./mapColorUtils";

export function useMoistureColor() {
  // Soil Moisture Colors, each representing a different status
  const pwpColor = useColorModeValue("#FB4741", "#B00000");
  const damageColor = useColorModeValue("#FB4741", "#B00000");
  const deficitColor = useColorModeValue("#FFCE1B", "#FFA500");
  const goodColor = useColorModeValue("#C9E9D2", "#2E8B57");
  const highColor = useColorModeValue(MOISTURE_INDEX_LIGHT_BLUE, "#008B8B");
  const runoffColor = useColorModeValue("#305CDE", "#0000FF");
  const undefinedColor = useColorModeValue("#D3D3D3", "#808080");

  const riskColor = useColorModeValue("#cbd5e0", "#7a7575ff");

  return {
    pwpColor, damageColor, deficitColor, goodColor, highColor, runoffColor, undefinedColor, riskColor,
  };
}
